export const Currency = {
	PI_POINTS: 'PI_POINTS',
	CHIPS_AND_PI_POINTS: 'CHIPS_AND_PI_POINTS',
	CHIPS: 'CHIPS',
};
